// extracted by mini-css-extract-plugin
export default {"iframeContainer":"bj6t7e"};